import React from 'react'
import { FormInput, FormDate, FormButton } from '@myxplor/forms'
import { PlusIcon, DeleteIcon } from '@myxplor/icons'

import { TypeAheadSelect } from '../../../../ui/forms/type-ahead'
import Grid from '../../../../ui/grid'
import { rolePositions, roleIsOther, statesAU } from './states'

const defaultValue = {
  serviceName: undefined,
  position: undefined,
  positionText: undefined,
  streetLine1: undefined,
  suburb: undefined,
  state: undefined,
  postcode: undefined,
  periodFrom: undefined,
  periodTo: undefined,
}

export const defaultValues = {
  OperationOfService: [],
}

export const OperationOfService = ({
  onChange,
  addKey,
  removeKey,
  errorAtKey,
  values = {},
  errors = {},
  loading,
}) => (
  <div>
    <fieldset>
      <legend>Previous Ownership/Operation of Child Care Service </legend>
        Has the person owned or operated a child care service(s) in the past five (5) years. This
        includes an interest in or a history of operating a child care service approved by a state or
        territory.
    </fieldset>

    {values.OperationOfService.map((service = {}, i) => (
      <div className="formValues--nested" key={i}>
        <fieldset>
          <legend>Name and Position</legend>
          <Grid>
            <FormInput
              name={`OperationOfService[${i}].serviceName`}
              value={service.serviceName}
              label="Name of the service"
              maxLength={120}
              onChange={onChange}
              errors={errorAtKey({ key: `OperationOfService[${i}].serviceName`, errors })}
              loading={loading}
              required
              compact
            />

            <TypeAheadSelect
              name={`OperationOfService[${i}].position`}
              label="Position of the personnel in the service"
              value={service.position}
              options={rolePositions}
              errors={errorAtKey({ key: `OperationOfService[${i}].position`, errors })}
              onChange={onChange}
              required
              compact
            />

            {roleIsOther(service) && (
              <FormInput
                name={`OperationOfService[${i}].positionText`}
                label="Position of the personnel"
                hint="Since you selected &quot;Other&quot;, please describe the role"
                value={service.positionText}
                errors={errorAtKey({ key: `OperationOfService[${i}].positionText`, errors })}
                maxLength={150}
                onChange={onChange}
                loading={loading}
                required
                compact
              />
            )}
          </Grid>
        </fieldset>

        <fieldset>
          <legend>Address</legend>
          <Grid>
            <FormInput
              name={`OperationOfService[${i}].streetLine1`}
              value={service.streetLine1}
              errors={errorAtKey({ key: `OperationOfService[${i}].streetLine1`, errors })}
              label="Street"
              maxLength={60}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            <FormInput
              name={`OperationOfService[${i}].suburb`}
              errors={errorAtKey({ key: `OperationOfService[${i}].suburb`, errors })}
              value={service.suburb}
              label="Suburb"
              maxLength={40}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            <TypeAheadSelect
              name={`OperationOfService[${i}].state`}
              errors={errorAtKey({ key: `OperationOfService[${i}].state`, errors })}
              value={service.state}
              label="State"
              options={statesAU}
              onChange={onChange}
              loading={loading}
              required
              compact
            />

            <FormInput
              name={`OperationOfService[${i}].postcode`}
              errors={errorAtKey({ key: `OperationOfService[${i}].postcode`, errors })}
              value={service.postcode}
              label="Postcode"
              maxLength={4}
              onChange={onChange}
              loading={loading}
              required
              compact
            />
          </Grid>
        </fieldset>

        <fieldset>
          <legend>Duration at service </legend>
          <Grid>
            <FormDate
              name={`OperationOfService[${i}].periodFrom`}
              value={service.periodFrom}
              errors={errorAtKey({ key: `OperationOfService[${i}].periodFrom`, errors })}
              label="From"
              onChange={onChange}
              loading={loading}
              required
              compact
            />
            <FormDate
              name={`OperationOfService[${i}].periodTo`}
              value={service.periodTo}
              errors={errorAtKey({ key: `OperationOfService[${i}].periodTo`, errors })}
              label="To"
              onChange={onChange}
              loading={loading}
              required
              compact
            />
          </Grid>
        </fieldset>

        <FormButton
          destructive
          confirm={`Deleting ${service.serviceName ||
              'this service'} can not be undone. Are you sure?`}
          onClick={e => {
            e.preventDefault()
            removeKey(`OperationOfService[${i}]`)
          }}>
          <DeleteIcon left />
            Delete Ownership/Operation
        </FormButton>
      </div>
    ))}

    <FormButton
      onClick={e => {
        e.preventDefault()
        addKey('OperationOfService', { ...defaultValue })
      }}>
      <PlusIcon left />Add new Ownership/Operation
    </FormButton>
  </div >
)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/operation-of-service.jsx